import React, { FC } from "react";
import "./style.scss";
import { sircapApi } from "shared/api/sircap";
import { useTranslation } from "react-i18next";
import { getCdnUrl } from "helpers/functions";

const langs = {
  en: "ENG",
  ru: "RUS",
  am: "ARM",
};

const getLang = (l: string) => {
  if (Object.keys(langs).includes(l)) {
    // @ts-ignore
    return langs[l];
  } else {
    return langs.en;
  }
};

type PropType = {
  term?: string;
  htmlText?: string;
  customText?: boolean;
  CustomDoc?: string;
  CustomName?: string;
  onClick?: () => void;
  onClickText?: string;
  PrivacyPolicy?: string;
  termsOfBrokerage?: string;
  termsOfBrokerageNew?: string;
  isChecked?: boolean;
  htmlForId: string;
  onChange?: () => void;
  className?: string;
  disabled?: boolean;
  smallFont?: boolean;
  onTermClick?: (e: any) => void;
  animation?: boolean;
  triggered?: boolean;
};
const TermsCheckbox: FC<PropType> = ({
  term,
  htmlText,
  isChecked,
  CustomDoc,
  CustomName,
  PrivacyPolicy,
  termsOfBrokerage,
  termsOfBrokerageNew,
  htmlForId,
  onChange,
  className,
  disabled,
  smallFont,
  onClick,
  onClickText,
  onTermClick,
  animation,
  triggered,
  customText,
}) => {
  const { i18n } = useTranslation();
  const lang = getLang(i18n.language);

  return (
    <>
      <label
        onChange={onChange}
        htmlFor={htmlForId}
        className={`${className} termsCheckbox`}
      >
        {animation ? (
          <label
            htmlFor={htmlForId}
            className={
              triggered && !isChecked
                ? "checkbox-with-animation checkbox-with-animation-triggered"
                : "checkbox-with-animation"
            }
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            {/*
              Отрисовка идёт строго от isChecked. Раньше здесь было своё
              внутреннее состояние `checked`, из-за чего галочка могла выглядеть
              отмеченной, пока родитель считал её снятой — форма не отправлялась
              без каких-либо признаков для клиента.
              onChange остаётся только на внешнем label (клик по нему активирует
              этот input), иначе обработчик сработал бы дважды и отменил сам себя.
            */}
            <input
              id={htmlForId}
              type="checkbox"
              checked={!!isChecked}
              readOnly
              style={{ display: "none" }}
            />
            <div className={`checkbox-box ${isChecked ? "checked" : ""}`}>
              {isChecked && (
                <svg viewBox="0 0 24 24" fill="none">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </div>
          </label>
        ) : (
          <input
            className="checkbox"
            type="checkbox"
            checked={isChecked}
            id={htmlForId}
            readOnly
            disabled={disabled}
          />
        )}

        {customText ? (
          <p
            onClick={(e) => onTermClick && onTermClick(e)}
            style={{ fontSize: smallFont ? "12px" : "14px" }}
            dangerouslySetInnerHTML={{ __html: term || "" }}
          />
        ) : (
          <p
            onClick={(e) => onTermClick && onTermClick(e)}
            style={{ fontSize: smallFont ? "12px" : "14px" }}
          >
            {term}
            {onClick && (
              <span onClick={onClick}>
                <a>{onClickText}</a>
              </span>
            )}
            {CustomDoc && (
              <a
                target="_blank"
                href={CustomDoc}
                rel="noreferrer"
                style={{ fontSize: smallFont ? "12px" : "14px" }}
              >
                {CustomName}
              </a>
            )}
            {PrivacyPolicy && (
              <a
                target="_blank"
                rel="noreferrer"
                href={getCdnUrl(`Privacy policy ${lang}.pdf`, "document")}
              >
                {PrivacyPolicy}
              </a>
            )}
            {termsOfBrokerage && (
              <a
                style={{ fontSize: smallFont ? "12px" : "14px" }}
                target="_blank"
                className="brokerage-services"
                href={getCdnUrl("Terms Of Brokerage Services.pdf", "document")}
                rel="noreferrer"
              >
                {termsOfBrokerage}
              </a>
            )}
            {termsOfBrokerageNew && (
              <a
                style={{ fontSize: smallFont ? "12px" : "14px" }}
                target="_blank"
                className="brokerage-services"
                href={getCdnUrl(
                  `Sirius_Capital_General_Terms_for_provision_of_investment services[NEW EDITION_20260429] ${
                    i18n.language === "ru" ? "RU" : "EN"
                  }.pdf`,
                  "document",
                )}
                rel="noreferrer"
              >
                {termsOfBrokerageNew}
              </a>
            )}
          </p>
        )}
      </label>
      {htmlText && customText && (
        <p
          onClick={(e) => onTermClick && onTermClick(e)}
          style={{ textAlign: "left", fontSize: "12px" }}
          dangerouslySetInnerHTML={{ __html: htmlText }}
        />
      )}
    </>
  );
};

export default TermsCheckbox;
